import { DialogPlugin, DialogInstance } from 'tdesign-vue';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import i18n, { i18n_t } from '@/locales/i18n';
import store from '@/renderer/store/index';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

type Parmas = {
  header?: string;
  body?: string;
  onConfirm?: Function;
  onCancel?: Function;
  finally?: Function;
  source?: string;
};
class UpgradeDialog {
  public dialog: any | DialogInstance = null;
  public isShowing = false;
  constructor() {
    this.dialog = null;
    this.isShowing = false;
  }
  public initDialog(params?: Parmas) {
    this.dialog = CustomDialog.confirm({
      theme: 'info',
      header: params?.header || i18n_t('暂不支持'),
      body: params?.body || i18n_t('升级为企业版可用'),
      width: '500px',
      confirmBtn: i18n_t('去升级'),
      onConfirm: () => {
        reporter.report('pay', {
          pay_source_click: params?.source || '',
        });
        this.dialog && this.dialog.hide && this.dialog.hide();
        params?.onConfirm && params.onConfirm();
        params?.finally && params.finally();
        this.destory();
        // 打开腾讯云工单页
        dispatchRouter(CONSTANT_URL.consoleBillUrl);
      },
      onClosed: () => {
        params?.onCancel && params.onCancel();
        params?.finally && params.finally();
        this.destory();
      },
    });
    this.isShowing = true;
  }
  public destory() {
    this.isShowing = false;
    this.dialog = null;
  }

  // 保证一个页面里只弹出一个窗口
  public show(params?: Parmas) {
    if (this.isShowing) {
      return;
    }
    if (!this.dialog) {
      this.initDialog(params);
    }
    reporter.report('pay', {
      pay_source_show: params?.source || '',
    });
    store.commit('setPaySource', params?.source || '');
    this.dialog && this.dialog.show && this.dialog.show();
  }
}
const upgradeDialog = new UpgradeDialog();
export default upgradeDialog;
